import React from 'react';
import PropTypes from 'prop-types';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';

import OfficeLookupActionButtons from '@components/table/actionButtons/OfficeLookupActionButtons';
import Button from '@components/smartAdminUI/Button';

const OfficeLookupTable = ({
  displayData,
  onOfficeSelect,
  isModal = false,
}) => {
  const officeSelected = row => onOfficeSelect(row);

  const actionsFormatter = (cell, row) => (
    <OfficeLookupActionButtons
      officeSelected={officeSelected}
      currRow={row}
    />
  );

  const hdrSortClasses = (_column, sortOrder) => `sorting_${sortOrder}`;

  const columns = [
    {
      dataField: 'actions',
      text: 'Actions',
      formatter: actionsFormatter,
      headerStyle: { width: '55px' },
    },
    {
      dataField: 'UniqueID',
      text: 'ID',
      hidden: true,
    },
    {
      dataField: 'OfficeMlsId',
      text: 'MLS ID',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: true,
    },
    {
      dataField: 'OfficeName',
      text: 'Office Name',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: true,
    },
    {
      dataField: 'OfficePhone',
      text: 'Phone',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: false,
    },
    {
      dataField: 'OfficeAOR',
      text: 'AOR',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: false,
    },
  ];

  const defaultSorted = [{
    dataField: 'OfficeMlsId',
    order: 'desc',
  }];

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <div className="btn-group" role="group">
      {
        options.map(option => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <Button
              variant={`${isSelect ? 'primary' : 'outline-primary'}`}
              key={option.text}
              onClick={() => onSizePerPageChange(option.page)}
            >
              {option.text}
            </Button>
          );
        })
      }
    </div>
  );

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      &nbsp;
      {`Showing rows ${from} to ${to} of ${size}`}
    </span>
  );

  const options = {
    firstPageText: '<<',
    hidePageListOnlyOnePage: true,
    lastPageText: '>>',
    nextPageText: '>',
    paginationTotalRenderer: customTotal,
    prePageText: '<',
    showTotal: true,
    sizePerPageList: [],
    sizePerPage: isModal ? 5 : 10,
    sizePerPageRenderer,
  };

  return (
    <BootstrapTable
      columns={columns}
      data={displayData}
      defaultSorted={defaultSorted}
      wrapperClasses="table-responsive"
      classes="dataTable"
      bordered={false}
      striped
      hover
      id="officesTable"
      keyField="OfficeMlsId"
      noDataIndication="Your search returned no results. Please try adjusting your search criteria."
      pagination={paginationFactory(options)}
    />
  );
};

OfficeLookupTable.propTypes = {
  displayData: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onOfficeSelect: PropTypes.func,
  isModal: PropTypes.bool,
};

export default OfficeLookupTable;
